module.exports = __webpack_public_path__ + "static/media/hotel-ad2.553918fd.jpg";